import './Button.css';
import { forwardRef, ReactNode } from 'react';
import { ButtonVariants } from './buttonTypes';
import { cx } from '#/Scripts/utilities/cx';
import Icon from '#sign-up/components/Icons/Icon';
import { IconPosition } from '#sign-up/components/Icons/iconTypes';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: ButtonVariants;
  className?: string;
  icon?: ReactNode | string;
  iconPosition?: IconPosition;
}

const getVariantClass = (variant: ButtonVariants) => {
  return variant;
};

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      variant = ButtonVariants.primary,
      className,
      type = 'button',
      icon,
      iconPosition = IconPosition.left,
      ...props
    },
    ref
  ) => {
    const getIcon = (position: IconPosition) => {
      if (!icon || position !== iconPosition) {
        return null;
      }
      let iconEl = icon;
      if (typeof icon === 'string') {
        iconEl = <Icon>{icon}</Icon>;
      }
      return iconEl;
    };
    return (
      <button className={cx('button', getVariantClass(variant), className)} type={type} {...props} ref={ref}>
        {getIcon(IconPosition.left)}
        {children}
        {getIcon(IconPosition.right)}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
